<script setup>
    import { markRaw, onMounted, onUnmounted, ref, defineAsyncComponent} from 'vue';

    import MainSiteLogo from './MainSiteLogo.vue';
    import MainMenuSingleItemComponent from './MainMenuSingleItemComponent.vue';
    import MainMenuHamburgerItemComponent from './MainMenuHamburgerItemComponent.vue';
    import SocialNetworkingComponent from '../../Helper/SocialNetworkingComponent.vue';
    import MainSiteLogoWhite from './MainSiteLogoWhite.vue';

    const props = defineProps({
        currentUrl: String,
    });

    const mobileBreakpointSmall = 640; // px

    const mobileBreakpoint = 1024; // px
    const mobileMenuState = ref(window.innerWidth > mobileBreakpoint);
    const smallMobileState = ref(window.innerWidth < mobileBreakpointSmall);

    function updateMenuState() {
        mobileMenuState.value = window.innerWidth > mobileBreakpoint;
        smallMobileState.value = window.innerWidth < mobileBreakpointSmall;
    }

    onMounted(() => {
        window.addEventListener('resize', updateMenuState);
    });

    onUnmounted(() => {
        window.removeEventListener('resize', updateMenuState);
    });

    const toggleMenu = () => {
        document.body.classList.toggle('menu-open');
        mobileMenuState.value = !mobileMenuState.value;
    }
</script>

<template>
    <div class="mx-auto w-full flex relative items-center justify-center">
        <div class="flex logo flex-none w-72 lg:w-100 items-center justify-center">
            <main-site-logo-white></main-site-logo-white>
        </div>
    </div>
</template>

<script>

</script>

<style scoped lang="scss">
.flex-60 {
    flex: 0 0 15rem;
}

/* Enter Transition */
.menu-enter-active,
.menu-leave-active {
    transition: opacity 0.5s;
}

.menu-enter-from,
.menu-leave-to {
    opacity: 0;
}
</style>

